import React ,{ useState }  from 'react'
import { navItems ,OurKnowledge } from '../../constants';
import { Link } from 'react-router-dom';
import styles from "../../style";
import { useStateContext } from '../../context/ContextProvider';
function Navebar({active ,DropActive}) {
  const { currentDir } = useStateContext();
  const [dropActiveMenu, setDropActiveMenu]=useState(false)
  return (

    <div className="hidden lg:flex items-center gap-10">
    <nav className="flex items-center gap-20">
    {navItems.map((item, index)=>(
         <Link to={item.link}
          key={item.id}
          onClick={() => {
      
            window.scrollTo(0, 0); 
        
          }}
          className={` ${ active === index + 1 ? "text-color-1 dark:text-white": " text-color-2  dark:hover:bg-gray-200"} text-lg justify-start items-start  font-kufi  font-semibold  dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors duration-300`}
        >
      <span>{currentDir === "ltr" ? item.titleEn : item.titleAr}</span>
      
       </Link>
      ))}
    </nav>
  </div>
  )
}

export default Navebar